// @ts-strict-ignore
import omit from 'lodash/omit';
import isEqual from 'lodash/isEqual';
import {VNode} from 'snabbdom';

import {Toast} from 'common/components/toast-area';

/**
 * Recursively omits the `elm` property (which is a reference to the parent node) of` VNode` type messages.
 * Useful to compare two VNode type messages.
 *
 * @param messageEl `message` property of `Toast`s. It can be plain text or HTML (as VNode|VNode[]).
 *
 */
const omitElm = (messageEl: VNode | string | VNode[]) => {
  if (typeof messageEl === `string`) {
    return messageEl;
  }

  if (Array.isArray(messageEl)) {
    return messageEl.map((el) => ({
      ...omit(el, `elm`),
      children: el.children?.map((childEl) => omitElm(childEl)),
    }));
  }

  return {
    ...omit(messageEl, `elm`),
    children: messageEl.children?.map((childEl) => omitElm(childEl)),
  };
};

export const areToastsEqual = (toastA: Toast, toastB: Toast) => {
  const ta = toastA && {
    ...omit(toastA, `closeToastCallback`, `ctaCallback`, `undoCallback`),
    message: omitElm(toastA.message),
  };

  const tb = toastB && {
    ...omit(toastB, `closeToastCallback`, `ctaCallback`, `undoCallback`),
    message: omitElm(toastB.message),
  };

  return isEqual(ta, tb);
};
